import React, { FC, useCallback } from 'react';

import classNames from 'classnames';
import { EcommerceEventsHelper } from 'shared/helpers/ecommerce';

import Button from '../../../../ui/Button';

import styles from './styles.module.scss';

type PreferredAreaItemProps = {
	name: string;
	id: string;
	isActive: boolean;
	onClick: (value: string, name: string) => void;
};

const PreferredAreaItem: FC<PreferredAreaItemProps> = ({ name, id, isActive, onClick }) => {
	const handleChange = () => {
		onClick(id, 'preferArea');
		EcommerceEventsHelper.selectBookingPreferredArea({ area: { _id: id, name } });
	};

	return (
		<Button
			className={classNames([styles.PreferredAreaItem, isActive && styles.PreferredAreaItemActive])}
			withShadow
			appearance={isActive ? 'primary-stroke' : 'stroke'}
			onClick={handleChange}>
			{name}
		</Button>
	);
};

export default PreferredAreaItem;
